import axiosInterceptorInstance from '@jobseeker/common-core/helpers/axiosInterceptor';

const getKeywordSearch = async (keyword: string) => {
  const axios = axiosInterceptorInstance(
    `${process.env.NEXT_PUBLIC_API_GATEWAY_GLADIATOR}/${process.env.NEXT_PUBLIC_PREFIX_JOB_SERVICE}`
  );

  const response = await axios.get(
    `${process.env.NEXT_PUBLIC_API_GATEWAY_GLADIATOR}/${process.env.NEXT_PUBLIC_PREFIX_JOB_SERVICE}/search/keyword?query=${keyword}`
  );

  if (response && response['status'] === 200) {
    return response['data'];
  }
};

export {getKeywordSearch};
